/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmExtractExtract } from "../../funcs/llmExtractExtract.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ExtractRequest$inboundSchema,
};

export const tool$llmExtractExtract: ToolDefinition<typeof args> = {
  name: "llm-extract-extract",
  description: `Extract structured data with inline JSON Schema

Extracts structured data from files using a custom inline JSON schema.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmExtractExtract(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
